import {
  getAddress,
  autocompleteAddress,
  validateAddress,
} from "@apis/address/address"
import { addressKeys } from "@apis/address/queryKeys"
import { skipToken, useQuery } from "@tanstack/react-query"
import { type IValidateAddressParams } from "@apis/address/types"

export const useGetAddressQuery = (address_guid: string | undefined) => {
  return useQuery({
    queryKey: addressKeys.detail(address_guid),
    queryFn: address_guid ? () => getAddress(address_guid) : skipToken,
  })
}

export const useGetAutocompleteAddressQuery = (
  address_lookup: string | undefined,
) => {
  return useQuery({
    queryKey: addressKeys.autocompletedAddress(address_lookup),
    queryFn: address_lookup
      ? () => autocompleteAddress(address_lookup)
      : skipToken,
  })
}

export const useGetValidateAddressQuery = (params?: IValidateAddressParams) => {
  return useQuery({
    queryKey: addressKeys.validatedAddress(params),
    queryFn: params ? () => validateAddress(params) : skipToken,
  })
}
